<template>
  <v-container grid-list-md fluid class="pt-0 pb-0">
    <v-card class="pa-2 card-r">
      <v-toolbar class="primary darken-2 card-r shadow-1 pl-3 text-white">
        <v-btn icon to="/classes">
          <v-icon color="white">keyboard_arrow_left</v-icon>
        </v-btn>
        <div class="text-xs-left f-20">{{modules.name}}</div>
        <!-- <v-spacer></v-spacer>
        <v-btn class="white shadow-1 mr-3 card-r" icon><v-icon class="textColor" @click="deleted = true">delete</v-icon></v-btn> -->
      </v-toolbar>
      <v-card class="pa-2 no-shadow grey lighten-4">
      <v-layout xs12>
        <v-flex xs12 offset-xs0 class="">
          <v-carousel  height="300"
                       class="card-r no-shadow mt-2" width="300" alt="alt text" >
            <v-carousel-item
                           :src="modules.image"
            ></v-carousel-item>
          </v-carousel>
        </v-flex>
      </v-layout>

      <v-card class="white no-shadow card-r mt-2">
        <v-flex xs12 offset-xs0 class="ml-3 mr-3">
          <div class="f-25 font-weight-bold textColor mt-2"></div>
        </v-flex>
        <!-- <v-layout xs12> -->
          <!-- <v-flex xs12 offset-xs0 class="ml-3 mr-3"> -->
            <!-- <span class="f-15 font-weight-bold text--darken-1 ">Price : - </span> -->
            <!-- <span class="f-15 font-weight-bold text--darken-1 ">$ {{modules.price}}</span> -->
          <!-- </v-flex> -->
        <!-- </v-layout> -->
        <v-layout xs12>
          <v-flex xs12 offset-xs0 class="text-xs-left ml-3">
            <span class="f-15 font-weight-bold text--darken-1">Minutes : - </span>
            <span class="f-15 font-weight-bold text--darken-1">{{modules.hours}} mins</span>
          </v-flex>
        </v-layout>
        <v-layout xs12 class="ml-3 mr-3 mt-2">
          <v-flex xs12>
            <div class="f-20 font-weight-bold mt-2">Description of this class</div>
          <v-flex xs12 md-12>
            <v-chip v-for="n in modules.tags" color="primary" text-color="white">{{n.key}} - {{n.description}}</v-chip>
          </v-flex>
          </v-flex>
        </v-layout>
      </v-card>
      </v-card>
    </v-card>
    <v-dialog v-model="deleted" max-width="290">
      <v-card class="card-r">
        <v-card-title class="f-17 text-capitalize">Are You Sure Want To Delete <span class="font-weight-bold f-17">{{modules.name}}</span>?</v-card-title>
        <v-card-actions>
          <v-spacer></v-spacer>
          <v-btn class="grey text-white left card-r" text @click="deleted = false">No</v-btn>
          <v-btn class="primary text-white card-r" text @click="deleted = false">Yes</v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>

  </v-container>
</template>

<script>
  /* eslint-disable */
    import ConfirmSignup from "../auth/ConfirmSignup";
  import { mapState, dispatch } from "vuex";

  export default {
    name: 'Viewclass',

    data () {
      return {
        deleted: false,
        TcoverPhoto: "https://irp-cdn.multiscreensite.com/f6d3566d/dms3rep/multi/mobile/iStock-540862480-2121x1414.jpg",
        tags:'',
        TProfileImg: "https://adayinthelifeimages.com/wp-content/uploads/2016/05/brisbane-headshots-commercial-photography-09.jpg",
        items : [
          {
            src: 'http://www.thedailytruffle.com/wp-content/uploads/2011/11/mercedes-benz-driving-school-teenagers-los-angeles-3.jpg'
          },
          {
            src: 'http://www.amgdrivingacademy.co.za/media/1194/gvw_5772.jpg'
          },
          {
            src: 'https://i.ytimg.com/vi/Vxekzd2lcfg/maxresdefault.jpg'
          },
          {
            src: 'https://d3lp4xedbqa8a5.cloudfront.net/imagegen/max/ccr/1023/-/s3/digital-cougar-assets/whichcar/2015/11/27/-1/Volvo-V40-driving-course.jpg'
          }
        ],

      }
    },
    created() {
      this.adminId = this.$route.params.id;
      Store.dispatch("Modules/getClassById", this.adminId).then(res => {
    });
  },
  computed: {
    ...mapState({
      modules: singlemodule => Store.state.Modules.singlemodule
    })
  },
      }

</script>

<style>
  .v-carousel__next .v-btn i, .v-carousel__prev .v-btn i{
    font-size: 24px !important;
  }
  .v-carousel__controls{
    display: none!important;
  }
</style>



// WEBPACK FOOTER //
// src/components/classes/Viewclass.vue